import { Flex } from '@weareberyl/design-system'
import { Card } from 'antd'
import CardSection from '~/components/shared/CardSection'
import SchemeButton, { Scheme } from '~/components/User/SchemeButton'
import UserLink, { User } from '~/components/UserLink'
import IconHeading from '~/components/Utils/IconHeading'
import MaybeLink from '~/components/Utils/MaybeLink'
import * as routes from '~/constants/routes'
import { useJourneySetBasicFragment } from '~/gql/generated/graphql'
import { IDProps } from '.'

const JourneySetSummary = ({
  id,
  withLink = false,
}: IDProps & { withLink?: boolean }) => {
  const { data: journey_set } = useJourneySetBasicFragment({
    id,
  })

  if ((journey_set?.journey_count ?? 1) < 2) return null

  const cardItems = [
    ...(journey_set.user?.id
      ? [{ key: 'User', value: <UserLink user={journey_set.user as User} /> }]
      : []),
    {
      key: 'State',
      value: journey_set.is_complete ? 'Complete' : 'In Progress',
    },
    {
      key: 'Journeys',
      value: journey_set.journey_count,
    },
    {
      key: 'Active Journeys',
      value: journey_set.active_journey_count,
    },
    ...(journey_set.scheme?.name
      ? [
          {
            key: 'Scheme',
            value: <SchemeButton scheme={journey_set.scheme as Scheme} />,
          },
        ]
      : []),
  ]

  return (
    <Card>
      <Flex mb={5}>
        <MaybeLink
          route={`${routes.JOURNEY_SETS}/${id}`}
          schemeId={journey_set.scheme?.id}
          withLink={withLink}
        >
          <IconHeading iconType="groupRide" withLink={withLink}>
            Group Ride {journey_set.id}
          </IconHeading>
        </MaybeLink>
      </Flex>
      <Flex justifyContent="space-between" width="100%">
        <CardSection mr={5} items={cardItems} />
      </Flex>
    </Card>
  )
}

export default JourneySetSummary
